import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { School } from '../../../../model/school.model';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl } from '@angular/forms';
import { Region } from 'src/app/model/region.model';
import { HelperService } from 'src/app/service/helper.service';
import { SchoolEntityService } from '../../service/school-entity.service';
import { County } from 'src/app/model/county';
import { debounceTime, distinctUntilChanged, filter, fromEvent, map, Observable, Subscription, tap } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';

@Component({
    selector: 'school-dropdown',
    templateUrl: './school-dropdown.component.html',
    styleUrls: ['./school-dropdown.component.scss']
})
export class SchoolDropdownComponent implements OnInit {
    @Input() selectSchoolIds: number[] = [];
    @Input() isMultiple: boolean = true;
    @Input() disableAutoComplete: boolean = false;
    @Input() autoRefreshOnRegionChange: boolean = false;
    @Input() autoRefreshOnCountyChange: boolean = false;
    @Input('reset') reset: boolean;
    @Input() required: boolean = false;
    @Input() disabled: boolean = false;
    @Input() filterSchoolDistricts: boolean = false;
    @Input() openSchoolsOnly: boolean = false;
    @Output() eventEmitterSchool = new EventEmitter<School[]>();

    @ViewChild('filterRef') filterRef: ElementRef;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSelect) matSelect: MatSelect;

    schoolForm: UntypedFormGroup;
    schoolIds: number[] = [];
    selectedSchoolIds: number[] = [];

    selectedSchoolName: string | undefined;
    filteredSchools: School[] = [];
    filteredSchoolsShow: School[] = [];

    regions: Region[] = [];
    counties: County[] = [];
    schoolDistricts: SchoolDistrict[] = [];
    schools: School[] = [];

    userRegion: Region = new Region();
    userRegionLoaded: boolean = false;
    userRegionSchools: School[] = [];

    loaded$: Observable<boolean>;
    isLoading: boolean = false;
    changed: boolean = true;
    allowFirstLoad: boolean = false;

    subs: Subscription[] = [];

    pageIndex: number = 0;
    pageSize: number = 5;

    constructor(private fb: UntypedFormBuilder, private schoolService: SchoolEntityService, private helperService: HelperService) {
        this.schoolForm = this.fb.group({
            schoolSelect: [''],
            filter: ['']
        });

        this.schoolService.setLoaded(true);
        this.loaded$ = schoolService.loaded$;
        let loadedSub = this.loaded$?.subscribe((loaded) => {
            if (!loaded) {
                this.schoolSelect.disable();
            } else {
                this.schoolSelect.enable();
            }
        });
        this.subs.push(loadedSub);
    }

    subscribers() {
        let lstUserProfileSub = this.helperService.lstUserProfileRegion$.subscribe((y: Region[]) => {
            this.userRegion = y[0];
        });
        this.subs.push(lstUserProfileSub);

        let selectedRegionsSub = this.helperService.selectedRegions$.subscribe((x: Region[]) => {
            if (x?.length <= 0) {
                let lstUserProfileSub2 = this.helperService.lstUserProfileRegion$.subscribe((y: Region[]) => {
                    this.regions = y;

                    this.autoRefreshOnRegionChange ? this.loadData(true) : null;
                });

                this.subs.push(lstUserProfileSub2);
            } else {
                this.regions = x;

                this.autoRefreshOnRegionChange ? this.loadData(true) : null;
            }

            this.changed = true;
        });
        this.subs.push(selectedRegionsSub);

        let selectedCountiesSub = this.helperService.selectedCounties$.subscribe((counties) => {
            this.counties = counties;
            this.autoRefreshOnCountyChange ? this.loadData(true) : null;
            this.changed = true;
        });
        this.subs.push(selectedCountiesSub);

        let selectedDistrictSub = this.helperService.selectedDistrict$.subscribe((schoolDistricts) => {
            this.schoolDistricts = schoolDistricts;
            this.changed = true;
            if (this.schoolDistricts && this.schoolDistricts.length > 0) {
                this.allowFirstLoad = true;
            }
            this.loadData(true);
        });
        this.subs.push(selectedDistrictSub);

        let filterInputSub = this.filterInput!.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((value: string) => {
            if (value.length === 0) {
                this.filteredSchools = this.schools;
                //this.onPageChange({ pageIndex: 0, pageSize: this.pageSize });
            } else {
                this.filteredSchools = this.schools.filter((school) => school.NAME.toLowerCase().includes(value.toLowerCase()));
                this.onPageChange({ pageIndex: 0, pageSize: this.pageSize });
            }
        });
        this.subs.push(filterInputSub);
    }

    emitSelect(schoolIds: number[]) {
        let output: School[] = [];
        this.selectedSchoolIds = Array.from(new Set(this.selectedSchoolIds.concat(schoolIds)));

        if (this.selectedSchoolIds.length > 0) {
            this.filteredSchools.forEach((filteredSchool) => {
                schoolIds.forEach((schoolId) => {
                    if (schoolId == filteredSchool.ID) {
                        output.push(filteredSchool);
                    }
                });
            });
        }

        // View updates
        this.selectedSchoolName = output[0]?.NAME;
        this.helperService.setSelectedSchoolListObject(output);
        this.filterInput?.patchValue('');
        output[0] ? this.goToPage(output[0].ID!) : this.goToPage(0);
        //Emits the code to the subscriber.
        this.eventEmitterSchool.emit(output);
    }

    ngOnInit(): void {
        // let initLoadedSub = this.schoolService.loaded$.subscribe((loaded) => {
        //     if (loaded) {
        //         setTimeout(() => {
        //             if (this.selectSchoolIds.length > 0) {
        //                 this.select(this.selectSchoolIds);
        //                 this.emitSelect(this.selectedSchoolIds);
        // 				this.selectSchoolIds = [];
        //             } else {
        //                 this.onPageChange({ pageIndex: 0, pageSize: this.pageSize });
        //             }
        //             initLoadedSub.unsubscribe();
        //         }, 5000);
        //     }
        // });
        // this.subs.push(initLoadedSub);

        this.subscribers();
    }

    ngOnDestroy() {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.reset) {
            this.deSelectAll();
        }

        if (this.disabled) {
            this.schoolSelect.disable();
        } else {
            this.schoolSelect.enable();
        }

        if (changes['selectSchoolIds']) {
            if (this.selectSchoolIds.length > 0) {
                this.select(this.selectSchoolIds);

                this.emitSelect(this.selectSchoolIds);
            } else {
                this.onPageChange({ pageIndex: 0, pageSize: this.pageSize });
            }

            this.selectSchoolIds = [];
        }
    }

    loadData(open: any, allowFirstLoad?: boolean) {
        if (open) {
            this.filterRef ? this.filterRef.nativeElement.focus() : null;
            if (allowFirstLoad || (this.selectSchoolIds && this.selectSchoolIds.length > 0)) {
                this.allowFirstLoad = true;
            }
            if (!this.changed || this.isLoading || !this.allowFirstLoad) return;
            this.schools = [];
            this.isLoading = true;
            this.schoolSelect.disable();
            this.schoolService.setLoaded(false);
            this.changed = false;
            this.filterInput!.patchValue('');

            setTimeout(() => {
                let workingRegions = this.removeDuplicateIDs(this.regions);
                let params: any = {};
                params['regions'] = workingRegions.map((region) => region.ID);
                params['schoolDistricts'] = this.schoolDistricts.map((schoolDistrict) => schoolDistrict.ID);
                params['counties'] = this.counties.map((county) => county.ID);
                params['filterSchoolDistricts'] = this.filterSchoolDistricts;
                params['openSchoolsOnly']=this.openSchoolsOnly

                this.schoolService.getWithQuery(params).subscribe((res) => {
                    this.schools = res;

                    if (workingRegions.length === 1 && workingRegions[0].ID === this.userRegion.ID) {
                        this.userRegionSchools = res;
                        this.userRegionLoaded = true;
                        this.helperService.setLoadingSchools(false);
                    }

                    this.schools.sort((a, b) => a.NAME.localeCompare(b.NAME));
                    this.filteredSchools = this.schools;

                    this.schoolService.setLoaded(true);

                    if (this.selectSchoolIds.length > 0) {
                        this.select(this.selectSchoolIds);

                        this.emitSelect(this.selectedSchoolIds);
                        this.selectSchoolIds = [];
                    } else if (this.schools.length === 1 && !this.disableAutoComplete) {
                        this.schoolSelect.patchValue([]);
                        this.selectAll();
                        this.emitSelect(this.selectedSchoolIds);
                    } else {
                        this.select(this.selectedSchoolIds);
                        this.emitSelect(this.selectedSchoolIds);
                    }

                    if (this.disabled) {
                        this.schoolSelect.disable();
                    } else {
                        this.schoolSelect.enable();
                    }
                    this.changed = false;
                    this.isLoading = false;
                });
            }, 1000);
        } else {
            this.select(this.selectedSchoolIds);
            this.emitSelect(this.selectedSchoolIds);
        }
    }

    removeDuplicateIDs(arr: Array<any>): Array<any> {
        arr = arr.filter((value, index, self) => index === self.findIndex((t) => t.place === value.place && t.ID === value.ID));

        return arr;
    }

    select(selection: any) {
        // Get current page
        this.filteredSchools = this.schools;

        if (this.isMultiple) {
            // Remove all selections in current page
            let currentPageIds = this.filteredSchoolsShow.map((filteredschool) => filteredschool.ID);
            this.selectedSchoolIds = this.selectedSchoolIds.filter((selectedSchoolId) => !currentPageIds.includes(selectedSchoolId));

            // Add current selection to total array
            this.selectedSchoolIds = Array.from(new Set(this.selectedSchoolIds.concat(selection)));

            // Remove all IDs that are not in available school districts
            let filteredSchools = this.filteredSchools.map((filteredSchool) => filteredSchool.ID);
            this.selectedSchoolIds = this.selectedSchoolIds.filter((selectedSchoolId) => filteredSchools.includes(selectedSchoolId));

            this.schoolSelect.patchValue(this.selectedSchoolIds);
        } else {
            if (Array.isArray(selection)) {
                this.schoolSelect.patchValue(selection[0]);
                this.selectedSchoolIds = selection;
            } else {
                this.schoolSelect.patchValue(selection);
                this.selectedSchoolIds = [selection];
            }

            this.goToPage(this.schoolSelect.value);
            this.emitSelect(this.selectedSchoolIds);
        }
    }

    selectAll() {
        let selected = this.schoolSelect.value; // Currently selected

        if (this.isMultiple) {
            selected = Array.isArray(selected) ? selected : [];
            this.selectedSchoolIds = Array.from(new Set(selected.concat(this.filteredSchools.map((school) => school.ID!)))); // Select all filtered (if any filter)
            this.schoolSelect.patchValue(this.selectedSchoolIds);
        } else {
            this.selectedSchoolIds = this.filteredSchools.map((school) => school.ID!);
            this.schoolSelect.patchValue(this.selectedSchoolIds[0]);
        }
    }

    deSelectAll() {
        this.reset = false;
        this.schoolSelect.patchValue([]);
        this.selectedSchoolIds = [];
        this.filterInput?.patchValue('');
        //this.emitSelect([]);
    }

    close() {
        this.matSelect.close();
    }

    get schoolSelect(): any {
        return this.schoolForm.get('schoolSelect');
    }
    get filterInput(): AbstractControl | null {
        return this.schoolForm.get('filter');
    }

    onPageChange($event: any) {
        $event.pageIndex = $event.pageIndex < 0 ? 0 : $event.pageIndex;

        this.pageIndex = $event.pageIndex;
        this.pageSize = $event.pageSize;

        this.filteredSchoolsShow = this.filteredSchools.slice($event.pageIndex * $event.pageSize, $event.pageIndex * $event.pageSize + $event.pageSize);
    }

    goToPage(id: number) {
        let index = this.filteredSchools.findIndex((filteredSchool) => filteredSchool.ID === id);
        let pageIndex = Math.floor(index / this.pageSize);

        if (this.paginator) {
            this.paginator.pageIndex = pageIndex;
        }
        this.onPageChange({ pageIndex: pageIndex, pageSize: this.pageSize });
    }
}
